<template>
    <div>

        <the-headersider></the-headersider>
        <base-card>

        <div class="tile">
<div class="tile-title">
    <div class="row">
        <div class="col-sm-6">
            <!-- services {{ invoiceServices }} -->
            <h4>Invoice Services</h4>
        </div>
        <div class="col-sm-6">
            <a :href="'/invoices/add_invoice_services/' + invoiceId" class="btn btn-outline-primary pull-right">New Invoice Service</a>
    </div>
    </div>
    <br>
    <br>
</div>
        <div class="tile-body">
            <div id="sampleTable_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"><div class="row"><div class="col-sm-12"><table class="table table-hover table-bordered dataTable no-footer" id="sampleTable" role="grid" aria-describedby="sampleTable_info">
                <thead>
                <tr role="row"><th class="sorting_asc" tabindex="0" aria-controls="sampleTable" rowspan="1" colspan="1" aria-sort="ascending" aria-label="Service: activate to sort column descending" style="width: 158.703px;">Description</th><th class="sorting" tabindex="0" aria-controls="sampleTable" rowspan="1" colspan="1" aria-label="Unit Price: activate to sort column ascending" style="width: 332.641px;">Delivery Number</th><th class="sorting" tabindex="0" aria-controls="sampleTable" rowspan="1" colspan="1" aria-label="Quantity: activate to sort column ascending" style="width: 182.25px;">Unit Price</th><th class="sorting" tabindex="0" aria-controls="sampleTable" rowspan="1" colspan="1" aria-label="Actions: activate to sort column ascending" style="width: 189.406px;">Quantity</th></tr>
                </thead>
                <tbody>
                
                
                    
                <tr role="row" class="odd" v-for="service in invoiceServices" :key="service.id">
                    <td class="sorting_1"><a>{{ service.description }}</a></td>
                    <td>{{ service.delivery_number }}</td>
                    <td>{{ service.unity_price}}</td>
                    <td>{{ service.quantity }}</td>
                    
                </tr></tbody>
            </table></div></div></div>
        </div>
    </div>
</base-card>

    </div>
</template>

<script>
  // import axios from 'axios';
  
  
  // import autotable from 'jspdf-autotable';
  // import TheVehicle from "../../components/items/TheVehicle.vue"
  
  export default {
      data(){
          return {
              revenues: null,
              deductions: null,
              currentClient: null
          }
  
      },
    
    computed: {
      
    
      invoiceId() {
        return this.$route.params.number
      },
       invoiceServices() {
        return this.$store.getters.invoiceServices(this.invoiceId) //(this.$route.params.client)
      },
      
     
  
  
    },
    created() {
        this.$store.dispatch('LoadInvoiceservices');   
      
        
       
      
    },
  
      
    methods: {
      
  
    },
   
  
    
  
   
    
  };
  </script>